<template>
    <div>
    </div>
</template>

<script>

import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'ws',
    components: {},
    data() {
        return {
            message: "",
            // dismissSecs: 20,
            // dismissCountDown: 0,      
            socket:null,
            channel:'',
            UserId:'',
            timer:0,
            CloseTime:0,
            ReConnectTimer:0,
            IsConnected:false,
            ReConnect:false,
        }
    },
    created(){
        this.$root.$refs.ws = this;
    },
    beforeDestroy(){
        clearTimeout(this.timer);
        this.socket.close(1000, "Closing from client");
        console.log('WebSocket Closed');
    },
    methods: {
        Connect(){
            try {
                this.socket = new WebSocket(`${process.env.WS_PATH}`);

                this.socket.onerror = function(err) {
                    console.log(err);
                };
                
                this.socket.onclose  = this.WebSocketClosed;
                this.socket.onmessage = this.MessageRecived;
                this.socket.onopen = this.WebSocketConnected;

            } catch(err) {
                console.log(err);
            }
        },
        WebSocketClosed(e){
            console.log('WebSocket Closed' + ',' + e.code);
            // this.socket.close(1000, "Closing from client");
            this.IsConnected = false;
            clearTimeout(this.timer);
            this.CloseTime += 1;
            if(this.CloseTime < 15){
                this.ClosedReConnect();
            }else{
                alert("連線已中斷。請重新登入," + e.code);
                // this.$router.push({
                //     name: 'loginPage',
                //     params: {
                //     }
                // });
            }
        },
        ClosedReConnect(){
            this.ReConnect = true;
            clearTimeout(this.ReConnectTimer)
            this.ReConnectTimer = setTimeout(() => {
                if(this.IsConnected == false){
                    this.Connect();
                }
            }, 1000)
        },
        WebSocketConnected(){
            this.IsConnected = true;
            this.CloseTime = 0;
            console.log('WebSocket Connected');
            this.Channel = 'User-' + sessionStorage.getItem('UserId');
            this.UserId = sessionStorage.getItem('UserId')
            this.socket.send(JSON.stringify({Channel:this.Channel,MessageType:0,UserId:this.UserId}));
            if(this.ReConnect){
                if(this.$root.$refs.chat != undefined){
                    this.$root.$refs.chat.getMessagesAPI();
                }
                this.ReConnect = false;
            }
            this.heartSocket();
        },
        heartSocket(){
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                if (this.socket.readyState === 1 || this.socket.readyState === 0) {
                    this.socket.send(JSON.stringify({MessageType:4,msg:'heartbeat'}))
                    this.heartSocket()
                } else {
                    this.Connect();
                }
            }, 59000)
        },
        MessageRecived(data)
        {
            var resturn_object = JSON.parse(data.data);  
            // console.log('WebSocket Data:', resturn_object);
                
             //-1:home , other:msg room
            if(sessionStorage.getItem('WhereAmI') == -1){//msg list
                this.$root.$refs.message.getNewestMessages(resturn_object);
            }else{
                this.$root.$refs.chat.getNewestMessages(resturn_object);
            }
        },
        stringFormat (formatted, args) {
            for (let i = 0; i < args.length; i++) {
                let regexp = new RegExp('\\{' + i + '\\}', 'gi')
                formatted = formatted.replace(regexp, args[i])
            }
            return formatted
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/ws.vue